<template>
  <swiper ref="mySwiper" :options="swiperOptions" @slideChange="slideChange" v-if="!reInitializeSwiper">
    <swiper-slide v-for="(product, i) in productList" :style="productTileStyle">
      <product-tile
        :key="'product_' + product.id + '_' + i"
        :i="i"
        :data="product"
        :quick-shop="true"
        :fit-height="true"
      />
    </swiper-slide>
    <swiper-slide v-if="showSeeAllTile">
      <see-all-carousel-tile :more-count="moreCounter" :is-brand="false" :link-to="seeAllLinkTo" />
    </swiper-slide>
  </swiper>
</template>

<script>
import { favoritesCarouselBase } from "./favoritesCarouselBase";
import SeeAllCarouselTile from "./see-all-carousel-tile.vue";

export default {
  mixins: [favoritesCarouselBase],
  components: { SeeAllCarouselTile },
  props: {
    products: {
      type: Array,
      default: [],
    },
  },
  computed: {
    productList: function () {
      return this.products?.slice(0, this.maxItems);
    },
    showSeeAllTile: function () {
      return this.products?.length > this.maxItems;
    },
    moreCounter: function () {
      return this.products?.length - this.maxItems;
    },
    productTileStyle: function () {
      if (this.underBreakpoint("md")) {
        return { width: `${window.innerWidth / 2 - 24}px` };
      }
      return undefined;
    },
  },
};
</script>
